import React, { type FunctionComponent, useContext } from 'react';

import type { RoleRequirementsConfig } from '../RoleRequirements/RoleRequirements';

export const ConfigContext = React.createContext<RoleRequirementsConfig>(
  {} as any,
);

interface Props {
  config: RoleRequirementsConfig;
  children?: React.ReactNode;
}

export const ConfigProvider: FunctionComponent<Props> = ({
  children,
  config,
}) => (
  <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
);

export const useConfig = (): RoleRequirementsConfig => {
  const context = useContext(ConfigContext);
  return context;
};
